/* NICHT MEHR VERWENDEN! ABGELÖST DURCH MORECORE/UI/GENERICDIALOG!! */

import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import domAttr from 'dojo/dom-attr';
import domStyle from 'dojo/dom-style';
import domClass from 'dojo/dom-class';
import domConstruct from 'dojo/dom-construct';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import template from './GenericDialog.html?raw';
// NOTE (JS2TS): the original define() also listed dojo/dijit/dojox utility + widget modules
// (connect, array, Color, keys, dijit _WidgetBase/_TemplatedMixin/_WidgetsInTemplateMixin, registry,
// on, form/TextBox, form/Button, Menu, MenuItem, form/ComboButton, Toolbar, request/xhr, dojox Standby,
// mouse, dnd/Moveable) that are never referenced in code and never used via data-dojo-type in the
// template — pure dead deps. Dropped (tsc would elide them anyway); runtime unchanged.

class GenericDialog extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;
    callback: any = function () { };
    destroyOnClose = true;
    buttoncount = 0;
    userdefinedCallback: any = null;
    userdefinedIconClass: any = null;
    closeOnUserDefined = true;
    _isDragActive = false;
    pos: any = {
        x1: null,
        x2: null,
        y1: null,
        y2: null

    };
    closeOnEnter = true;
    _standbyTargetNodeName = "textNode";

    _onClick_Close(): void {
        this.close(0);
    }
    _onClick_Button_Cancel(evt?: any): void {
        this.close(0);
    }
    _onClick_Button_OK(evt?: any): void {
        this.close(1);
    }

    _onClick_Button_YES(evt?: any): void {
        this.close(2);
    }

    _onClick_Button_NO(evt?: any): void {
        this.close(-1);
    }

    _onClick_Button_Close(evt?: any): void {
        this.close(0);
    }

    _onClick_Button_NEXT(evt?: any): void {
        this.close(3);
    }

    _onClick_Button_BACK(evt?: any): void {
        this.close(4);
    }

    _onClick_Button_userdefined(evt?: any): void {
        if (typeof (this.userdefinedCallback) == "function") {
            if (this.closeOnUserDefined === true) {
                this.close(this.userdefinedCallback);
            }
            this.userdefinedCallback();
        }
    }

    _setCallbackAttr(value: any): void {
        this.callback = value;
    }

    _onKeyUp_Dlg(evt: any): void { // Esc?
        if (evt.keyCode == 13 && this.closeOnEnter === true) {
            this.close(1);
        }
        if (evt.keyCode == 27) {
            this.close(0);
        }
    }

    hideSubtitleNode(bHide?: any): void {
        if (typeof (bHide) == "undefined") {
            bHide = true;
        }

        if (bHide === true) {
            domClass.add(this.subTitleNode, "w3-hide");
        } else {
            domClass.remove(this.subTitleNode, "w3-hide");
        }
    }

    // JS2TS: duplicate key in original object literal — overwritten by the later _setHeaderAttr (dead). Kept commented.
    //_setHeaderAttr(value: any): void {
    //    domAttr.set(this.headerNode, "innerHTML", value);
    //}

    _setSubTitleAttr(value: any): void {
        domAttr.set(this.subTitleNode, "innerHTML", value);
        domClass.remove(this.subTitleNode, "w3-hide");
    }

    // JS2TS: duplicate key in original object literal — overwritten by the later _getHeaderAttr (dead). Kept commented.
    //_getHeaderAttr(): any {
    //    return domAttr.get(this.headerNode, "innerHTML");
    //}

    _getSubTitleAttr(): any {
        return domAttr.get(this.subTitleNode, "innerHTML");
    }

    _setContentAttr(value: any): void {
        domAttr.set(this.textNode, "innerHTML", value);
    }

    _getContentAttr(): any {
        return domAttr.get(this.textNode, "innerHTML");
    }

    addNodeToContent(node: any, pos?: any): void {
        if (typeof (pos) == "undefined") pos = "last";
        domConstruct.place(node, this.textNode, pos);
    }

    addNodeToSubtitle(node: any, pos?: any): void {
        if (typeof (pos) == "undefined") pos = "last";
        domConstruct.place(node, this.subTitleNode, pos);

        domClass.remove(this.subTitleNode, "w3-hide");
    }

    _setHeaderAttr(value: any): void {

        domAttr.set(this.headerNode, "innerHTML", value);
    }

    _getHeaderAttr(): any {
        return domAttr.get(this.headerNode, "innerHTML");
    }

    _setTopCloseBtnAttr(value: any): void {
        if (value === true) {
            domStyle.set(this.topCloseBtn, "display", "block");
        } else {
            domStyle.set(this.topCloseBtn, "display", "none");
        }
    }

    showActionContainer(bool?: any): void {
        //console.log("showActionContainer", this.buttoncount);
        if (this.buttoncount < 0) {
            this.buttoncount = 0;
        }

        if (typeof (bool) == "undefined") {
            bool = this.buttoncount > 0;
        }

        if (bool == true) {
            domClass.remove(this.actionContainer, "w3-hide");
        }

        else {
            domClass.add(this.actionContainer, "w3-hide");
        }
    }

    open(): void {
        this.show();
    }

    Open(): void {
        this.show();
    }

    Show(): void {
        this.show();
    }

    show(): void {
        domStyle.set(this.modalDlg, "display", "block");
        this.emit("shown", this);
    }

    Close(): void {
        this.close();
        this.emit("closed", {});
    }

    hide(): void {
        this.close();
    }

    Hide(): void {
        this.close();
    }

    close(result?: any): void {
        domStyle.set(this.modalDlg, "display", "none");

        if (typeof (result) == "undefined") {
            result = 0;
        } else if (typeof (result) == "function") {
            result();
        }

        //  callback-function nahezu in echtzeit aufrufen. aber asynchron ...
        //
        setTimeout(lang.partial(this.callback, result), 1);

        if (this.destroyOnClose === true) {
            //  selbstzerstörung in 1 Sekunde :-)
            //
            setTimeout(lang.hitch(this, "destroy"), 1000);
        }
    }

    setUserdefinedButton(text: any, iconClass: any, callback: any, bCloseOnClick?: any): void {


        domAttr.set(this.btn_userdefined_text, "innerHTML", text);

        if (typeof (iconClass) != "undefined" && iconClass != "") {
            domClass.add(this.btn_userdefined_icon, iconClass);
            this.userdefinedIconClass = iconClass;
            domAttr.set(this.btn_userdefined_icon, "innerHTML", "&nbsp;");
        } else {
            domClass.remove(this.btn_userdefined_icon, this.userdefinedIconClass);
            domAttr.set(this.btn_userdefined_icon, "innerHTML", "");
        }

        this.userdefinedCallback = callback;
        if (bCloseOnClick === true || bCloseOnClick === false) {
            this.closeOnUserDefined = bCloseOnClick;
        }

        if (typeof (this.userdefinedCallback) == "function") {
            domStyle.set(this.btn_userdefined, "display", "block");
            this.buttoncount++;
        } else {
            domStyle.set(this.btn_userdefined, "display", "none");
            this.buttoncount--;
        }

        this.showActionContainer();

    }

    _setYesAttr(value: any): void {
        if (value === true) {
            domStyle.set(this.btn_yes, "display", "block");
            this.buttoncount++;
        } else {
            domStyle.set(this.btn_yes, "display", "none");
            this.buttoncount--;
        }

        this.showActionContainer();
    }

    _setNoAttr(value: any): void {
        if (value === true) {
            domStyle.set(this.btn_no, "display", "block");
            this.buttoncount++;
        } else {
            domStyle.set(this.btn_no, "display", "none");
            this.buttoncount--;
        }

        this.showActionContainer();
    }

    _setOkAttr(value: any): void {
        if (value === true) {
            domStyle.set(this.btn_ok, "display", "block");
            this.buttoncount++;
        } else {
            domStyle.set(this.btn_ok, "display", "none");
            this.buttoncount--;
        }

        this.showActionContainer();
    }

    _setCloseAttr(value: any): void { // alias
        this.set("CloseBtn", value);
    }

    _setCloseBtnAttr(value: any): void {
        if (value === true) {
            domStyle.set(this.btn_close, "display", "block");
            this.buttoncount++;
        } else {
            domStyle.set(this.btn_close, "display", "none");
            this.buttoncount--;
        }

        this.showActionContainer();
    }

    _setCancelAttr(value: any): void {
        if (value === true) {
            domStyle.set(this.btn_cancel, "display", "block");
            this.buttoncount++;
        } else {
            domStyle.set(this.btn_cancel, "display", "none");
            this.buttoncount--;
        }

        this.showActionContainer();
    }

    _setBackAttr(value: any): void {
        if (value === true) {
            domStyle.set(this.btn_back, "display", "block");
            this.buttoncount++;
        } else {
            domStyle.set(this.btn_back, "display", "none");
            this.buttoncount--;
        }

        this.showActionContainer();
    }

    _setNextAttr(value: any): void {
        if (value === true) {
            domStyle.set(this.btn_next, "display", "block");
            this.buttoncount++;
        } else {
            domStyle.set(this.btn_next, "display", "none");
            this.buttoncount--;
        }

        this.showActionContainer();
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any); // standard code aus basisklasse
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.buttoncount = 0;
        this.placeAt(document.body);

        //var dnd = new Moveable(this.modalNode, { handle: this.headerNode });
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
    destroy(): void {
        super.destroy.apply(this, arguments as any);
    }
}
GenericDialog.prototype.declaredClass = 'more.GenericDialog';

export default mdsWidget(GenericDialog);
